<template>
  <div>


    <b-row data-toggle="collapse" :data-target="'#collapse-'+issue.id" aria-expanded="false"
           :aria-controls="'#collapse-'+issue.id"
           style="border-top: 2px solid #9e9e9e;padding: 7px;padding-top:10px;padding-bottom:0;background-color: #fff"
           :style="{borderTop: headerStyles(issue)}">


      <b-col md="2" cols="3" class="my-0">
        <b-badge v-if="issue.board" pill variant="info" class="text-right p-1" style="float: right"
                 :style="{backgroundColor: boardColor(issue.board.id)}">
          {{ issue.board.title }}
        </b-badge>

      </b-col>

      <b-col md="10" cols="9" class="my-0" style="min-width: 200px">
        <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{ issue.title }}</h6>


      </b-col>

      <b-col v-if="issueMoreDetailShow" md="2" cols="3" class="my-1">


        <span v-b-tooltip.hover title="اولویت زیاد" v-if="issue.priority == 3" class="text-right text-danger" size="sm"><i
            class="fas fa-thermometer-full"></i></span>
        <span v-b-tooltip.hover title="اولویت متوسط" v-else-if="issue.priority == 2" class="text-right text-dark"
              size="sm"><i class="fas fa-thermometer-half"></i></span>
        <span v-b-tooltip.hover title="اولویت کم" v-else-if="issue.priority == 1" class="text-right text-secondary"
              size="sm"><i class="fas fa-thermometer-empty"></i></span>


      </b-col>

      <b-col v-if="issueMoreDetailShow" md="6" cols="5" class="my-1">



        <router-link :to="{path :'/issue/'+issue.id }"
                     :id="'tooltip-target-issueShow-'+issue.id"
                     style="cursor: pointer" class="text-default  ml-2">
          <i class="fas fa-eye"></i>
        </router-link>
        <b-tooltip placement="bottom"  :target="'tooltip-target-issueShow-'+issue.id"
                   triggers="hover">
          <small>نمایش Issue </small>
        </b-tooltip>


        <span v-if="issue.contact_id && issue.contact" :id="'tooltip-target-'+issue.id"
              style="cursor: pointer" class="text-success  ml-2">
                                              <i class="fas fa-address-book"></i>
                                          </span>
        <b-tooltip placement="bottom" v-if="issue.contact_id && issue.contact" :target="'tooltip-target-'+issue.id"
                   triggers="hover">
          <small>مشتری: </small>
          {{ issue.contact.last_name }}
        </b-tooltip>


        <span v-if="issue.project_id && issue.project" :id="'tooltip-target-project-'+issue.id"
              style="cursor: pointer" class="text-info ml-2">
                                              <i class="fas fa-handshake"></i>
                                          </span>
        <b-tooltip placement="bottom" v-if="issue.project_id && issue.project"
                   :target="'tooltip-target-project-'+issue.id" triggers="hover">
          <small>پروژه: </small>
          {{ issue.project.title }}
        </b-tooltip>


        <span v-if="issue.process">
                        <span v-if="issue.process.steps">
                              <span v-for="(step, stepIconListIndex) in issue.process.steps"
                                    v-if="step.id === issue.step_id" :key="'stepIconList'+stepIconListIndex"
                                    :id="'tooltip-target-step-'+issue.id"
                                    style="cursor: pointer" class="text-dark ml-2">
                                              <i class="fas fa-random"></i>
                    </span>
                            <b-tooltip v-for="(step, stepTooltipListIndex) in issue.process.steps"
                                       v-if="step.id === issue.step_id" :key="'stepTooltipList'+stepTooltipListIndex"
                                       placement="bottom" :target="'tooltip-target-step-'+issue.id" triggers="hover">
                                <small>مرحله: </small>
                                {{ step.title }}
                            </b-tooltip>
                        </span>
                    </span>


        <span :id="'tooltip-target-created-'+issue.id"
              style="cursor: pointer" class="text-secondary  ml-2">
                                              <i class="fas fa-calendar"></i>
                                          </span>
        <b-tooltip placement="bottom" :target="'tooltip-target-created-'+issue.id" triggers="hover">
          <small>تاریخ ثبت: </small>
          {{ issue.created_at| moment("dddd, jD jMMMM") }}
        </b-tooltip>


      </b-col>

      <b-col v-if="issueMoreDetailShow" md="4" cols="4" class="my-1 text-left text-sm">
        <!--                                          <small>-->
        <!--                                              <b-col md="12" class="text-left text-sm">-->
        <!--                                                  <small>-->

        <!--                                                      <router-link  v-if="issue.contact_id && issue.contact" :title="issue.contact.first_name +' '+issue.contact.last_name" :to="{path: '/contact/profile/'+issue.contact_id, params: {id: issue.contact_id}}"-->
        <!--                                                                   class="btn btn-success btn-sm" size="sm">-->
        <!--                                                          مشتری:-->

        <!--                                                          {{issue.contact.last_name}}-->
        <!--                                                      </router-link>-->

        <!--                                                  </small>-->
        <!--                                              </b-col>                                          </small>-->


        <!--                                          <b-badge  v-if="issue.contact_id && issue.contact" size="sm" variant="success"   class=" m-1" >-->
        <!--                                              <small>مشتری: </small>-->
        <!--                                              {{issue.contact.last_name}}</b-badge>-->


        <!--                                          <b-badge v-if="issue.project" size="sm" variant="info"   class=" m-1">-->
        <!--                                              <small>پروژه: </small>-->
        <!--                                              {{issue.project.title}}</b-badge>-->


        <!--                                          <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >-->
        <!--&lt;!&ndash;                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>&ndash;&gt;-->
        <!--                                                    <b-badge  v-if="step.id === issue.step_id" variant="light">{{step.title}}</b-badge>-->
        <!--                                              &lt;!&ndash;                                                    <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>&ndash;&gt;-->
        <!--                                                </span>-->


        <small class="text-color-blue mt-1 mr-2">

          <span v-if="issue.type_object" v-b-tooltip.hover :title="issueTypeText(issue)"
                v-text="issue.type_object.title" class="badge badge-secondary pt-1"
                :style="{backgroundColor: typeBadgeStyles(issue)}"></span>

        </small>
      </b-col>


    </b-row>


    <b-row>
      <b-col colspan="7" class="collapse" :id="'collapse-'+issue.id" style="background-color: #f6f6f6; color: #333">


        <issueItemShow :issue="issue" :issueMoreDetailShow="issueMoreDetailShow">
        </issueItemShow>


      </b-col>

    </b-row>


  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>


import Multiselect from 'vue-multiselect'

import draggable from "vuedraggable";
import issueItemShow from "./item";


export default {
  name: 'list',
  components: {


    Multiselect,

    draggable,

    issueItemShow,


  },


  props: {
    issue: {},
    issueMoreDetailShow: true,

  },

  data() {
    return {

      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },
      loadMore: true,
      page: 0,
      pageSize: 10,
      voice: '',

      courseCategories: [],
      fileCategories: [],
      forumCategories: [],
      forums: [],


      issueText: 0,
      newIssue: {
        intro: '',
        state: '0',
        title: '',
        text: '0',

        voice: '',
        file: '',
        image: '',
        video: '',

        news: 0,
        course_id: null,
        course_category_id: null,
        forum_id: null,
        forum_category_id: null,
        fileLib_tags: null,
        // issue_likes:null,
        // userLike:null,

        type: 'ticket',
        project_id: null,
        board_id: 2,
        users: [],

        priority: 2,
        due_date: null,
        tags: [],

      },

      rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

      showVoiceRecorder: false,
      showFileUploader: false,
      showImageUploader: false,
      showVideoUploader: false,

      src: null,
      srcPlay: null,

      issueAsCourse: false,
      issueAsForum: false,

      courseDisabled: false,
      forumDisabled: false,

      newComment: '',
      newReply: '',

      options: [],

      selectedTags: [],
      tags: [],
      isLoading: false,


      typeOptions: [
        {value: 'ticket', text: 'پیگیری (Ticket)', selected: true},
        {value: 'bug', text: 'ایراد (Bug)'},
        {value: 'task', text: 'فعالیت (Task)'},
        {value: 'user-story', text: 'لیست (User Story)'},
        {value: 'epic', text: 'نسخه/فیچر (Epic)'},
        {value: 'lead', text: 'سرنخ/فرصت (Lead)'},
        {value: 'meeting', text: 'ملاقات/جلسه/رویداد'},

      ],


      warningModal: false,


      boardsWithIssues: [],
      steps: [],


      addIssue: {
        parent_id: null,
        reply_id: null,
        sprint_id: null,
        board_id: null,
        process_id: null,
        section_id: null,
        step_id: null
      },


    }
  },


  mounted() {

    // this.getSteps()
    // this.getIssues()
    // this.getFileCategories()
    // this.getForumCategories()
    // this.getForums()
  },


  methods: {

    getIssues() {
      this.$parent.getIssues()
    },


    headerStyles(issueType) {
      if (issueType.type == 1)
        return '2px solid #880e4e'
      else if (issueType.type == 2)
        return '2px solid #f50057'
      else if (issueType.type == 3)
        return '2px solid #8e24aa'
      else if (issueType.type == 4)
        return '2px solid #263238'
      else if (issueType.type == 5)
        return '2px solid #dd2c00'
      else if (issueType.type == 6)
        return '2px solid #00c853'
      else if (issueType.type == 7)
        return '2px solid #0097a7'
      else if (issueType.type == 8)
        return '2px solid #0288d1'
      else if (issueType.type == 9)
        return '2px solid #0208ff'
      else if (issueType.type == 10)
        return '2px solid #eeb600'
      else if (issueType.type == 10)
        return '2px solid #0e8e2e'
      else if (issueType.type == 11)
        return '2px solid #888'
      else
        return '2px solid #888888'
    },


    boardColor(boardID) {
      if (boardID == 1)
        return '#ee6600'
      else if (boardID == 2)
        return '#ffd600'
      else if (boardID == 3)
        return '#aeb130'
      else if (boardID == 4)
        return '#64dd17'
      else if (boardID == 5)
        return '#0097a7'
      else if (boardID == 6)
        return '#00bfa5'
      else
        return ''
    },

    typeBadgeStyles(issueType) {
      if (issueType.type == 1)
        return '#880e4e'
      else if (issueType.type == 2)
        return '#f50057'
      else if (issueType.type == 3)
        return '#8e24aa'
      else if (issueType.type == 4)
        return '#263238'
      else if (issueType.type == 5)
        return '#dd2c00'
      else if (issueType.type == 6)
        return '#00c853'
      else if (issueType.type == 7)
        return '#0097a7'
      else if (issueType.type == 8)
        return '#0288d1'
      else if (issueType.type == 9)
        return '#0208ff'
      else if (issueType.type == 10)
        return '#eeb600'
      else if (issueType.type == 10)
        return '#0e8e2e'
      else if (issueType.type == 11)
        return '#888'
      else
        return '#888888'
    },


    issueTypeText(issueType) {
      if (issueType.type == 1)
        return 'سرنخ (Lead)'
      else if (issueType.type == 2)
        return 'فرصت (Opportunity)'
      else if (issueType.type == 3)
        return 'ملاقات/جلسه/رویداد'
      else if (issueType.type == 4)
        return 'پیگیری (Ticket)'
      else if (issueType.type == 5)
        return 'ایراد (Bug)'
      else if (issueType.type == 6)
        return 'فعالیت (Task)'
      else if (issueType.type == 7)
        return 'لیست/شرح (Story)'
      else if (issueType.type == 8)
        return 'مجموعه/امکانات (Epic)'
      else if (issueType.type == 9)
        return 'پیام/تلفن (Message)'
      else if (issueType.type == 10)
        return 'گزارش/خبر (Report)'
      else if (issueType.type == 11)
        return 'سایر'
      else
        return 'سایر'
    },


    bootstrapColor(key) {
      if (key == 0)
        return 'info'
      if (key == 1)
        return 'danger'
      if (key == 2)
        return 'warning'
      if (key == 3)
        return 'success'
      if (key == 4)
        return 'secondary'
      else
        return 'primary'
    },


    styleColor(boardID) {
      if (boardID == 1)
        return '#ee6600'
      else if (boardID == 2)
        return '#ffd600'
      else if (boardID == 3)
        return '#aeb130'
      else if (boardID == 4)
        return '#64dd17'
      else if (boardID == 5)
        return '#0097a7'
      else if (boardID == 6)
        return '#00bfa5'
      else
        return ''
    },


    getSteps(processID = null) {
      var app = this;
      axios.get('/api/intro/steps/' + processID, app.auth)
          .then(function (response) {
            app.steps = response.data.data.data
          })
          .catch(function (e) {
            console.log(e.response);
          });
    },


  },


  computed: {},
  watch: {}


}
</script>


<style>

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}


.user-image {
  height: 30px;
  width: 30px;
  overflow: hidden;
  display: inline-block;
  text-align: right;
  float: right;
  border-radius: 100%;
  border: 2px solid #CDDC39;
  margin-left: 5px
}


.style-img-textarea {
  top: 18px;
  right: 25px;
}

@media (max-width: 767px) {

  .daynamik-bg-intro {
    padding: 0 30px;
    padding-right: 33px;
    background: #F6FAFB;

  }


}


.modal-content {
  border: #00acc1 2px solid;
  /*-webkit-border-radius: 0px !important;*/
  /*-moz-border-radius: 0px !important;*/
  /*border-radius: 0px !important;*/
}


</style>
